import { CompanyNumber } from "@components/virtual-receptionist/widget";
import { gatewayPhone } from "src/gateways/gatewayPhone";

export const updateCompanyNumberAction = async (id: string, phone: string, name: string): Promise<CompanyNumber> => {
    try {
        const res = await gatewayPhone.patch(`/company-numbers/${id}`, {
            phoneNumber: phone,
            name: name,
        });
        return res.data
    } catch (error) {
        console.log(error)
    }
};